export default __webpack_public_path__ + "static/media/ina_view.c47e2975.png";